import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { BorderBox, TopicsSection, Spinner } from "../components/index.js";
import { LeftArrowCircleIcon } from "../assets/icons/index.js";
import helpCategories from "../data/helpCategories.js";
import requestHandler from "../utils/requestHandler.js";

export default function HelpArticle() {
  const navigate = useNavigate();
  const { topicSlug } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadArticle = async () => {
      setLoading(true);
      const res = await requestHandler({
        path: `articles/${topicSlug}`,
        method: "GET",
      });
      if (res.success) {
        setArticle(res.data);
      }
      setLoading(false);
    };
    loadArticle();
  }, [topicSlug]);

  const handleCategoryClick = (categorySlug) => {
    navigate("/help", { state: { selectedCategory: categorySlug } });
  };

  return (
    <div className="flex h-[calc(100vh-4rem)] md:h-[calc(100vh-4rem)] flex-row justify-between gap-4 pb-4">
      {/* Main Content */}
      <div
        id="content"
        className="flex flex-col gap-4 h-full overflow-y-auto no-scrollbar w-full md:w-3/4"
      >
        <h1 className="text-4xl uppercase text-black dark:text-lz-concrete">
          <div className="flex flex-row gap-2 items-center">
            <LeftArrowCircleIcon
              className="dark:fill-lz-concrete w-10 h-10 cursor-pointer"
              onClick={() => navigate("/help")}
            />
            Help
          </div>
        </h1>

        {loading ? (
          <Spinner />
        ) : article ? (
          <BorderBox className="h-auto">
            <h2 className="text-2xl font-semibold text-lz-ink-mid dark:text-lz-concrete mb-1">
              {article.title}
            </h2>
            {article.human_readable_last_update_at && (
              <span className="text-sm text-lz-ink-mid/70 dark:text-lz-concrete mb-4 block">
                {article.human_readable_last_update_at.charAt(0).toUpperCase() +
                  article.human_readable_last_update_at.slice(1)}
              </span>
            )}
            <div
              className="text-lz-ink-mid dark:text-lz-concrete leading-relaxed [&_img]:max-w-full [&_img]:h-auto [&_img]:rounded-lg [&_img]:my-2"
              dangerouslySetInnerHTML={{ __html: article.body }}
            />
          </BorderBox>
        ) : (
          <BorderBox className="h-auto">
            <p className="text-lz-ink-mid dark:text-lz-concrete">
              Article not found.
            </p>
          </BorderBox>
        )}
      </div>

      {/* Desktop Categories Sidebar */}
      <TopicsSection
        onTopicClick={handleCategoryClick}
        topics={helpCategories}
        className="hidden md:block"
      />
    </div>
  );
}
